import React from 'react'
import First from './tabs/first';
import Second from './tabs/second';

function Tabs({Tab, reason, setReason,setWords,Words}) {

  return (
    <div>
      {Tab === 1 && <First setReason={setReason} reason={reason}/>}
      {Tab === 2 && <Second setWords={setWords} Words={Words}/>}
    </div>
  )
}

export default Tabs